// Uygulama genelinde para birimi Türk Lirası'dır. Tutarlar Türkçe biçimde
// (binlik ayraç nokta, ondalık virgül) ve sembol sonda gösterilir: "1.234,56 ₺".
const tryFormatter = new Intl.NumberFormat("tr-TR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatTRY(amount: number): string {
  return `${tryFormatter.format(amount)} ₺`;
}

// Sembolsüz sayısal biçim (ör. giriş alanları, bileşik metinler için).
export function formatAmount(amount: number): string {
  return tryFormatter.format(amount);
}
